module.exports = __webpack_public_path__ + "static/img/chaxun.1131c80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chaxun.jpg
// module id = TFWg
// module chunks = 1